import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../../../Assets/UserDetails.css";
import "../../../Assets/Postsmanage.css";
import { ReactComponent as VerifiedIcon } from "../../../Assets/images/icon/verifiedIcon.svg";
import { ReactComponent as ArrowBackIcon } from "../../../Assets/images/icon/ArrowBack Icon.svg";
import { Avatar, Button, Row, Col, Spin, message } from "antd";
import { useNavigate } from "react-router-dom";
import RecipeMediaPost from "./RecipeMediaPost";
import { DeleteOutlined } from "@ant-design/icons";
import DeletePostModal from "./DeletePostModal";
import { fetchRecipe } from "../useAPIDetails/usePostRelatedAPI";

const GeneralPostpage = () => {
  const [postData, setPostData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPostDetails = async () => {
      try {
        if (!id) {
          throw new Error("Post id is missing in the URL.");
        }
        const result = await fetchRecipe(id);
        setPostData(result.data.post);
      } catch (error) {
        message.error(
          error?.response?.data?.message ||
            "Something went wrong while fetching post details."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPostDetails();
  }, [id]);

  const handleDelete = () => {
    setIsModalVisible(true);
  };

  if (loading) {
    return (
      <div className="user-detailed-container">
        <Spin size="large" />
      </div>
    );
  }

  if (!postData) {
    return (
      <div className="user-detailed-container">
        <p>No post data available.</p>
      </div>
    );
  }
  const handleBackClick = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/post-management");
    }
  };

  const { createdByUser, pictures, title, keywords, reactionsCount, location } =
    postData;
  return (
    <>
      <div className="user-detailed-container">
        <div className="header-user-detail sticky-header">
          <div className="arrow-icon-left pointer" onClick={handleBackClick}>
            <ArrowBackIcon />
          </div>
          <div className="header-texthead">General Post Details</div>
        </div>

        <Row>
          <Col span={11} style={{ padding: "35px 35px 0 35px" }}>
            <RecipeMediaPost
              media={pictures?.map((pic) => ({
                type: pic?.picture?.fileFormat,
                url: pic.picture.fileUrl,
              }))}
            />
          </Col>
          <Col span={13} style={{ padding: "35px 35px 0 35px" }}>
            <div className="flex-center-between">
              <div className="flex-center-between" style={{ gap: 5 }}>
                <Avatar
                  src={createdByUser.profilePicture?.fileUrl}
                  style={{
                    backgroundColor: "#87d068",
                    width: "60px",
                    height: "60px",
                  }}
                />
                <div className="flex-center">
                  <div className="post-detail-text">
                    {createdByUser.userName}
                  </div>
                  {createdByUser.verified && (
                    <div className="verified-icon-size27px">
                      <VerifiedIcon />
                    </div>
                  )}
                </div>
              </div>
              <Button
                danger
                style={{
                  marginRight: "20px",
                }}
                type="link"
                icon={<DeleteOutlined />}
                onClick={handleDelete}
              />
            </div>
            <div className="flex-center-between">
              <div className="section-post">
                <div className="post-detail-heading">Caption: </div>
                <div className="post-detail-text">{title || "---"}</div>
              </div>
              <div className="font-like-details">{reactionsCount} Likes</div>
            </div>
            <div className="section-post">
              <div className="post-detail-heading">Restaurant:</div>
              <div className="post-detail-text">{location?.name || "---"}</div>
            </div>
            <div className="section-post">
              <div className="post-detail-heading">Keywords: </div>
              <div className="post-detail-text">
                {keywords?.map((keyword) => keyword?.name).join(" ") || "---"}
              </div>
            </div>
          </Col>
        </Row>
        <DeletePostModal
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          postId={id}
        />
      </div>
    </>
  );
};

export default GeneralPostpage;
